import styled from "styled-components";

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  border: none;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);

  text-align: center;

  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  max-width: 960px;
`;

export const ContainerCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  border: none;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);

  text-align: center;

  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  max-width: 960px;

  min-height: 25vh;
`;

export const CardBody = styled.div`
  padding: 1.25rem;
  margin-bottom: 30px;
`;

export const HardText = styled.div`
  font-size: 1.25rem;
  padding: 10px;
  color: #636463;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
`;

export const SexyLine = styled.div`
  margin: 25px 50px;
  height: 2px;
  background: #51a3a4;
  background: -webkit-gradient(
    linear,
    0 0,
    100% 0,
    from(white),
    to(white),
    color-stop(50%, #51a3a4)
  );
`;

export const SimpleText = styled.p`
  padding: 10px;
  color: #636463;
  margin-top: 0;
  margin-bottom: 1rem;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: 400;
  line-height: 1.5;
`;
export const LinkText = styled.span`
  color: #418384;
  transition: all 0.25s ease-in-out;
  text-decoration: none;
  background-color: transparent;
  font-weight: 450;
`;
